import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNav from '../base/BottomNav';
import AdminMoreSheet from './AdminMoreSheet';
import { useCompanyLogo } from '@/hooks/useCompanyLogo';

const navItems = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: 'ri-home-line', exact: true },
  { to: '/admin/leads', label: 'Leads', icon: 'ri-user-add-line', exact: false },
  { to: '/admin/jobs', label: 'Jobs', icon: 'ri-briefcase-line', exact: false },
  { to: '/admin/contracts', label: 'Contracts', icon: 'ri-file-text-line', exact: false },
];

export default function AdminBottomNav() {
  const [moreOpen, setMoreOpen] = useState(false);

  return (
    <>
      <BottomNav
        items={navItems}
        moreButton={{
          label: 'More',
          icon: 'ri-apps-line',
          onClick: () => setMoreOpen(true),
          active: moreOpen,
        }}
      />
      <AdminMoreSheet open={moreOpen} onClose={() => setMoreOpen(false)} />
    </>
  );
}